import { render, staticRenderFns } from "./DatosPedidoComponent.vue?vue&type=template&id=981ffc22&scoped=true"
import script from "./DatosPedidoComponent.vue?vue&type=script&lang=js"
export * from "./DatosPedidoComponent.vue?vue&type=script&lang=js"
import style0 from "./DatosPedidoComponent.vue?vue&type=style&index=0&id=981ffc22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981ffc22",
  null
  
)

export default component.exports